@if (currentBadgeType != null) {
  <div class="badge-container">
    <span class="badge-msg" [ngClass]="currentBadgeType">{{ getMessageTranslationKey() | translate }}</span>
    @if (shouldShowAction()) {
      <div
        class="action-container">
        <button
          (click)="actionClick.emit()"
          [disabled]="loading || disabled"
          class="secondary-btn btn-sm badge-btn"
          [attr.aria-label]="getAriaLabelTranslationKey() | translate">
          {{ getActionTranslationKey() | translate }}
        </button>
        @if (loading) {
          <i class="ficon-spinner ficon-spin" aria-live="polite" [attr.aria-label]="'common_loading'| translate"></i>
        }
      </div>
    }
  </div>
}
